import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material";
import { LineChart } from "@mui/x-charts/LineChart";

interface ChartProps {
    data: {
        month: string;
        actual: number;
        forecast: number;
    }[];
}

export const PerformanceChart: React.FC<ChartProps> = ({ data }) => {
    
    const theme = useTheme();
    const xLabels = data.map((item) => item.month);

    return (
        <Box sx={{ width: "100%", height: "100%" }} my={2}>
            <LineChart
                xAxis={[{ scaleType: "point", data: xLabels }]}
                yAxis={[{ valueFormatter: (v: number) => `${v / 1000}K` }]}
                series={[
                    {
                        data: data.map((item) => item.actual),
                        label: "Actual",
                        color: theme.palette.success.light,
                        area: true,
                        showMark: false,
                    },
                    {
                        data: data.map((item) => item.forecast),
                        label: "Forecast",
                        color: theme.palette.primary.main,
                        showMark: false,
                    },
                ]}
                height={350}
                margin={{ top: 10, right: 20, left: 0, bottom: 50 }}
                grid={{ vertical: true, horizontal: true }}
                slotProps={{
                    legend: {
                        direction: "horizontal",
                        position: { vertical: "bottom", horizontal: "center" },
                    },
                }}
            />
        </Box>
    );
};